import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IBullhornFields } from '../weight-table/weights-interfaces';
import { IStrategyCustomMapping, IStrategySelections } from './master-identification-options.component';

@Injectable()
export class MasterIdentificationService {

  availableMasterIdentificationFields: IBullhornFields;
  customStrategyMapping: IStrategyCustomMapping;
  strategySelections: IStrategySelections;
  constructor(
    private http: HttpClient
  ) {
  }

  getAvailableFields(): Observable<IBullhornFields> {
    return this.http.get<any>(`${environment.duplikitUrl}/master-identification/available-fields`);
  }

  getStrategy(): Observable<any> {
    return this.http.get<any>(`${environment.duplikitUrl}/master-identification/strategy`);
  }

  getCustomStrategy(): Observable<IStrategyCustomMapping> {
    return this.http.get<IStrategyCustomMapping>(`${environment.duplikitUrl}/master-identification/selections`);
  }
}
